import { TypographyOptions } from '@mui/material/styles/createTypography';
import { isMobile } from 'react-device-detect';
import { PaletteOverride } from '../palette/palette';
import { fontFamily } from '../fontFamily';

export class TypographyOverride {
  static fontFamily = fontFamily.roboto;

  static h1 = {
    fontFamily: fontFamily.drukWideMedium,
    fontWeight: 900,
  };

  static h2 = {
    fontFamily: fontFamily.drukWideMedium,
    fontWeight: 900,
    fontSize: isMobile ? 24 : 40,
    lineHeight: 1.5,
    letterSpacing: 'normal',
  };

  static h3 = {
    fontFamily: fontFamily.drukWideMedium,
    fontWeight: 900,
    fontSize: 24,
    lineHeight: 1.27,
    letterSpacing: '0.0125rem',
  };

  static h4 = {
    fontSize: '1.125rem',
    fontWeight: 900,
    lineHeight: 1.22,
    letterSpacing: 'normal',
  };

  static h5 = {
    fontSize: '1.125rem',
    lineHeight: 1.22,
    letterSpacing: 'normal',
  };

  static h6 = {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.5,
    letterSpacing: '0.03125rem',
    textTransform: 'uppercase' as const,
  };

  static body1 = {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.03125rem',
  };

  static body2 = {
    fontWeight: isMobile ? 500 : 600,
    fontSize: 16,
    lineHeight: '24px',
  };

  static bodyGrey = {
    fontFamily: fontFamily.roboto,
    fontSize: 12,
    fontWeight: 700,
    textTransform: 'uppercase' as const,
    color: PaletteOverride.grey[400],
  };

  static button = {
    fontSize: '0.8125rem',
    lineHeight: 1.31,
    padding: '0 18px',
    letterSpacing: '0.3px',
    fontWeight: 600,
    color: PaletteOverride.grey[50],
    borderRadius: '100px',
  };

  static caption = {
    fontWeight: isMobile ? 400 : 300,
    lineHeight: 'normal',
    letterSpacing: 'normal',
  };

  static subtitle1 = {
    fontSize: 24,
    fontWeight: 300,
    lineHeight: 1.5,
    letterSpacing: 'normal',
  };

  static subtitle2 = {
    color: PaletteOverride.grey[800],
    fontSize: '0.75rem',
  };
}

const typography: TypographyOptions = {
  h1: TypographyOverride.h1,
  h2: TypographyOverride.h2,
  h3: TypographyOverride.h3,
  h4: TypographyOverride.h4,
  h5: TypographyOverride.h5,
  h6: TypographyOverride.h6,
  body1: TypographyOverride.body1,
  body2: TypographyOverride.body2,
  bodyGrey: TypographyOverride.bodyGrey,
  button: TypographyOverride.button,
  caption: TypographyOverride.caption,
  subtitle1: TypographyOverride.subtitle1,
  subtitle2: TypographyOverride.subtitle2,
};

export default typography;
